import Image from 'next/image'

import swileCardImage from '/src/lib/assets/images/card-swile.png'

export const SwileCardImage = () => (
  <Image
    src={swileCardImage}
    width={136}
    alt="Cartão Swile"
    priority
    className="-ml-24 hidden min-[1000px]:block"
  />
)
